import {
  TablePage,
  AddPage,
  EditPage,
  ViewPage,
} from 'src/views/notification/notificationtrigger'
import pathMap from 'src/paths/PathMap_Notification_Trigger'

class NotificationTriggerRoute {
  getConfigurations() {
    return [
      {
        exact: true,
        path: pathMap.NOTIFICATION_TRIGGER_LIST_VIEW,
        component: TablePage
      },
      {
        exact: true,
        path: pathMap.NOTIFICATION_TRIGGER_ADD_VIEW,
        component: AddPage
      },
      {
        exact: true,
        path: pathMap.NOTIFICATION_TRIGGER_EDIT_VIEW,
        component: EditPage
      },
      {
        exact: true,
        path: pathMap.NOTIFICATION_TRIGGER_DETAILS_VIEW,
        component: ViewPage
      }
    ]
  }
}

export default NotificationTriggerRoute
